<mat-form-field class="w-100 p-0" [hideRequiredMarker]="true" appearance="outline" subscriptSizing="dynamic">
  <mat-label
    >{{ placeholder() }}
    @if (isRequired()) {
      <span class="required-marker"> *</span>
    }
  </mat-label>
  <mat-select
    (closed)="onSelectClosed()"
    (openedChange)="openedChange($event)"
    [multiple]="multiple()"
    [compareWith]="compareOptions"
    [formControl]="control"
    panelClass="vitamui-select-panel"
    #matSelect
  >
    <mat-select-trigger>
      @if (getSelectedOptionsCount() > 0) {
        @if (multiple()) {
          @if (allSelectedLabel() && getSelectedOptionsCount() === allOptions.length) {
            {{ allSelectedLabel() }}
          } @else {
            {{ getSelectedOptionsCount() }} {{ getSelectedOptionsCount() | i18nPlural: nbSelectedItemsMap | translate }}
          }
        } @else {
          {{ selectedOptions[0].label }}
        }
      }
    </mat-select-trigger>

    @if (showOnlySelectedOption) {
      <button type="button" (click)="toggleShowOnlySelectedOption()" class="btn link small d-flex ml-auto mr-2">
        <i class="vitamui-icon vitamui-icon-chevron-left"></i>
        <span>
          {{ 'SELECT.COMPLETE_SELECTION' | translate }}
        </span>
      </button>

      <button type="button" (click)="clearAllSelectedOptions()" class="btn link small ml-2">
        <i class="vitamui-icon vitamui-icon-delete"></i>
        <span>
          {{ 'SELECT.EMPTY_SELECTION' | translate }}
        </span>
      </button>

      <mat-divider class="separator"></mat-divider>
      <div [style.height]="containerHeightInSelectedItemsView">
        <cdk-virtual-scroll-viewport itemSize="48" #scrollViewport class="h-100" minBufferPx="240" maxBufferPx="480">
          <div class="vitamui-mat-select-options">
            <ng-container *cdkVirtualFor="let option of selectedOptions; let last = last; let index = index">
              <mat-option
                [id]="index.toString()"
                [value]="option.key"
                (onSelectionChange)="onSelectionChange($event)"
                [disabled]="option.disabled"
                [vitamuiTooltip]="option.info"
              >
                <span [innerHTML]="option.label | highlight: searchText()" vitamuiCommonEllipsis [isToolTipOnMouseEnter]="true"></span>
              </mat-option>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            </ng-container>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    } @else {
      @if (enableDisplaySelected() && multiple()) {
        <button
          type="button"
          (click)="toggleShowOnlySelectedOption()"
          [disabled]="getSelectedOptionsCount() === 0"
          class="btn link small d-flex ml-auto mr-2"
        >
          <i class="vitamui-icon vitamui-icon-chevron-right"></i>
          <span> {{ 'SELECT.CONSULT_SELECTION' | translate }} ({{ getSelectedOptionsCount() }}) </span>
        </button>
      }

      @if (enableSearch()) {
        <div class="m-2">
          <vitamui-common-search-bar
            #searchBar
            (clear)="resetSearchBar()"
            (searchChanged)="onSearch($event)"
            name="element-search"
            [placeholder]="searchBarPlaceHolder() || placeholder()"
            searchButtonColor="primary"
          ></vitamui-common-search-bar>
        </div>
      }

      @if (loading()) {
        <!--Keep this hidden option otherwise the spinner is not displayed-->
        <mat-option style="display: none"></mat-option>
        <mat-spinner class="vitamui-spinner medium" style="margin: auto"></mat-spinner>
      } @else {
        <div [style.height]="containerHeightInSearchView">
          <cdk-virtual-scroll-viewport itemSize="48" #scrollViewport class="h-100" minBufferPx="240" maxBufferPx="480">
            <div class="vitamui-mat-select-options">
              @if (enableSelectAll() && multiple()) {
                <div class="mat-mdc-option" (click)="toggleSelectAll($event)">
                  <mat-pseudo-checkbox
                    [state]="isAllSelected() ? 'checked' : 'unchecked'"
                    class="mat-mdc-option-pseudo-checkbox"
                  ></mat-pseudo-checkbox>
                  <span class="mat-mdc-option-text text normal secondary bold">
                    {{ selectAllLabel() | translate }}
                  </span>
                </div>
                <mat-divider></mat-divider>
              }

              <ng-container *cdkVirtualFor="let option of displayedOptions; let last = last; let index = index">
                <mat-option
                  [id]="String(index + 1)"
                  [value]="option.key"
                  (onSelectionChange)="onSelectionChange($event)"
                  [disabled]="option.disabled"
                  [vitamuiTooltip]="option.info"
                >
                  <span [innerHTML]="option.label | highlight: searchText()" vitamuiCommonEllipsis [isToolTipOnMouseEnter]="true"></span>
                </mat-option>
                @if (!last) {
                  <mat-divider></mat-divider>
                }
              </ng-container>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      }
    }
  </mat-select>

  <div matSuffix class="select-arrow">
    <i class="vitamui-icon vitamui-icon-unfold-more"></i>
  </div>
</mat-form-field>

<vitamui-form-errors [control]="control" [errorMessageMap]="errorMessageMap()"></vitamui-form-errors>
